<template>
    <div class="trdemark-infoquery" >
        <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right" style="
    margin-top:13px;margin-left:14px;">
        <el-breadcrumb-item>商标管理</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/TrademarkSearch' }" >商标查询</el-breadcrumb-item>
       <el-breadcrumb-item class="breadSelected">商标信息详情页</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 内容区域 -->
    <div class="trdemark-main">
        <div class="trdemark-title">
            {{sbbasicDataDetails.ap}}
        </div>
        <!-- 基本信息 -->
        <div class="basic-info">
            <div class="trdemark-line">
                <div class="basic-header">
                    <div></div>
               基本信息
            </div>
            </div>
            <div class="basic-list">
                <div class="mark-img">
                    <img :src="sbbasicDataDetails.anImg" alt="">
                </div>
                <ul class="basic-name">
                    <li>商标名称：<span>{{sbbasicDataDetails.ti}}</span></li>
                    <li>申请/注册号：<span>{{sbbasicDataDetails.an}}</span></li>
                    <li>申请日：<span>{{sbbasicDataDetails.apd}}</span></li>
                    <li>注册日：<span>{{sbbasicDataDetails.gd}}</span></li>
                </ul>
                <ul class="basic-name">
                <li>注册公告：<span>{{sbbasicDataDetails.gdvl ? sbbasicDataDetails.gdvl + "期" : ""}}</span></li>
                <li>初审日：<span>{{sbbasicDataDetails.pd}}</span></li>
                 <li>初审公告：<span>{{sbbasicDataDetails.pdvl ? sbbasicDataDetails.pdvl + "期" : ""}}</span></li>
                 <li>专用权期限：<span>{{sbbasicDataDetails.ed}}</span></li>
                 </ul>
                <ul class="basic-name">
                    <li>国际分类：<span>{{sbbasicDataDetails.ic}}</span></li>
                    <li>类似群组：<span>{{sbbasicDataDetails.grp}}</span></li>
                </ul>
            </div>
        </div>
        <!-- 申请人信息 -->
        <div class="basic-info">
             <div class="trdemark-line">
                <div class="basic-header">
                    <div></div>
               申请人信息
            </div>
            </div>
            <ul class="basic-name applicant">
                <li class="aoolicant-name">申请人名称：<span>{{sbbasicDataDetails.ap}}</span></li>
                <li>申请人地址：<span>{{sbbasicDataDetails.apad}}</span></li>
            </ul>
        </div>
        <!-- 代理机构信息 -->
        <div class="basic-info">
            <div class="trdemark-line">
                <div class="basic-header">
                <div></div>
               代理机构信息
            </div>
            </div>
        <ul class="basic-name agent">
            <li>代理机构：<span>{{sbbasicDataDetails.ag}}</span></li>
        </ul>
    </div>
    <!-- 流程信息-最后流程信息 -->
    <div class="basic-info no-border">
        <div class="trdemark-line">
                <div class="basic-header">
                <div></div>
               流程信息-最后流程信息
            </div>
            </div>
             <ul class="basic-name agent">
                 <span >{{sbbasicDataDetails.zhlcsj}} </span>{{ sbbasicDataDetails.zhlczt }}
              {{ sbbasicDataDetails.zhlczzt }}
            </ul>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
    data() {
        return {

        }
    },
    computed: {
        ...mapState(['sbbasicDataDetails'])
    }

    
}
</script>
<style lang="less" >
.trdemark-infoquery {
 
  
    width: 98%;
    height: 98%;
    position: absolute;
    bottom: 0;
    background: #fff;
    left: 20px;
    overflow-y: auto;


}
        .basic-name {
           list-style: none;
           overflow: auto;
        }
        .basic-name > li {
            margin-bottom: 12px;
            font-size: 14px;
            color: #6b6b6b;
            line-height: 22px;
        }
        .basic-name >li span {
            color: #000;
            font-size: 14px;
            line-height: 22px;
        }
.applicant{
    display: flex;
    justify-content: flex-start;
    margin: 0px 0 30px 30px;
  
    .aoolicant-name {
        margin-right: 50px;
    }
}
.agent {
    display: flex;
    justify-content: flex-start;
    margin: 0px 0 30px 30px;
  
   
}
.agent span {
    margin-bottom: 14px;
}
.trdemark-line {
    width: 80%;
}
.basic-header {
        display: flex;
        height: 30px;
        font-size: 16px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 700;
        color: #1773d5;
        line-height: 22px;
        letter-spacing: 0.5px;
    }
.basic-header > div {
    width: 4px;
    height: 16px;
    background: #1b75d5;
    border-radius: 2px;
    margin: 4px 27px 0px 0px;
        }
.trdemark-main {
    overflow: hidden;
    min-height: 500px;
    margin-top: 7px;
    margin-left: 14px;
    // width: 100%;
    min-height: 600px;
    background: #fff;
    .trdemark-title {
    width: 98%;
    margin:14px auto;
    line-height: 40px;
    background: #e7f3ff;
    text-align: center;
    font-size: 16px;
    font-family: PingFangSC, PingFangSC-Medium;
    font-weight: 500;
    color: #1773d5;
    letter-spacing: 0.5px;
    }
    .basic-info {
        width: 90%;
        margin: 14px;
        border-bottom: 1px solid #dddddd;
    
    
        .basic-list {
            margin-left: 40px;
            display: flex;
            justify-content: space-between;
            padding: 15px 20px;
            
        .mark-img {
            width: 138px;
            height: 130px;
            // background-color: pink;
            img {
                width: 100%;
                height: 100%;
            }
        }

        }
    }
 
}
   .no-border {
    border: none !important;
}
.agent {
    font-size: 14px;
}


</style>